import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { goToLogin, onSessionExpired, redirectedRecently } from '../utils/sessionExpiry';

const SECONDS = 5;

/**
 * Says once that the Flow session expired and sends the person to sign in, back to the same page (utils/sessionExpiry.js).
 * Counts down 5 s, then goes; "Sign in now" goes at once. If Flow already sent them to sign in less than a minute ago,
 * it waits for the click instead, so a session that cannot be restored never loops.
 */
export default function SessionExpiredNotice() {
  const [open, setOpen] = useState(false);
  const [left, setLeft] = useState(SECONDS);
  const [auto, setAuto] = useState(true);

  useEffect(() => onSessionExpired(() => {
    setAuto(!redirectedRecently());
    setOpen(true);
  }), []);

  useEffect(() => {
    if (!open || !auto) { return undefined; }
    if (left <= 0) { goToLogin(); return undefined; }
    const timer = setTimeout(() => setLeft((n) => n - 1), 1000);
    return () => clearTimeout(timer);
  }, [open, auto, left]);

  return (
    <Modal
      closable={false}
      footer={<Button onClick={goToLogin} type="primary">Sign in now</Button>}
      keyboard={false}
      maskClosable={false}
      open={open}
      title="Your session has expired"
      width={420}
    >
      <p role="status" style={{ margin: 0 }}>
        Your work is saved.{' '}
        {auto ? `Signing you in again in ${Math.max(left, 0)} s…` : 'Sign in again to continue where you were.'}
      </p>
    </Modal>
  );
}
